import React, { FC, useState } from "react";
import { Button, Modal, ModalProps, Dropdown, Form, Checkbox } from "semantic-ui-react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import "react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css";

interface Props extends ModalProps {
    onClose: () => void;
    onDownload: (dateRange: Date[]) => void;
}

const DownloadArchiveWindow: FC<Props> = (props) => {
    const { onClose, onDownload } = props;

    const [usingCalendar, setUsingCalendar] = useState<boolean>(false);

    const [defaultDateRange, setDefaultDateRange] = useState<any>(null);
    const [customDateRange, setCustomDateRange] = useState<any>(null);

    const defaultDateRangeOptions = {
        today: [new Date()],
        "last 3 days": [new Date(new Date().setDate(new Date().getDate() - 2)), new Date()],
        "last week": [new Date(new Date().setDate(new Date().getDate() - 6)), new Date()],
        "last 2 weeks": [new Date(new Date().setDate(new Date().getDate() - 13)), new Date()],
        "last month": [new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()],
    };

    const dropdownItems = Object.keys(defaultDateRangeOptions).map((item) => {
        return { value: item, text: item };
    });

    const onDownloadHandler = async () => {
        onClose();
        // @ts-ignore
        onDownload(customDateRange ? customDateRange : defaultDateRangeOptions[defaultDateRange]);
    };

    const usingCalendarHandler = async () => {
        if (usingCalendar) {
            setCustomDateRange(null);
            setUsingCalendar(false);
        } else {
            setDefaultDateRange(null);
            setUsingCalendar(true);
        }
    };

    return (
        <div>
            <Modal
                size="large"
                style={{ minWidth: "70%", maxWidth: "95%" }}
                open={true}
                closeOnDimmerClick={false}
                closeOnEscape={false}
            >
                <Modal.Header>Specify date range</Modal.Header>
                <Modal.Content>
                    <>
                        <Form>
                            <Form.Field>
                                <Dropdown
                                    placeholder="Choose date range"
                                    fluid
                                    selection
                                    options={dropdownItems}
                                    disabled={usingCalendar}
                                    onChange={(event, { value }) => setDefaultDateRange(value)}
                                    value={defaultDateRange}
                                />
                            </Form.Field>

                            <Form.Field>
                                <Checkbox label="Choose dates using calendar" onClick={usingCalendarHandler} />
                            </Form.Field>

                            {usingCalendar && (
                                <Form.Field>
                                    <SemanticDatepicker type="range" onDateChange={(data) => setCustomDateRange(data)} />
                                </Form.Field>
                            )}
                        </Form>
                    </>
                </Modal.Content>

                <Modal.Actions>
                    <Button circular onClick={onDownloadHandler} disabled={!customDateRange && !defaultDateRange}>
                        Download
                    </Button>
                    <Button circular onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default DownloadArchiveWindow;
